/**
 * Chaves de API do projeto (#1783), que o ex-kit-server usa para carregar os dados do cliente.
 *
 * As rotas existiam desde a #1783 sem tela: a chave saía pelo `dev_integration`. A tela entrou
 * com a #1784, nas configurações do projeto. A chave em claro só vem na criação e na renovação.
 */

import apiClient from "./client";
import type { components } from "@/types/api.generated";

export type ProjectApiKey = components["schemas"]["ProjectApiKeyResponse"];
export type CreatedProjectApiKey = components["schemas"]["CreatedProjectApiKeyResponse"];

export async function listProjectApiKeys(projectId: string): Promise<ProjectApiKey[]> {
  const res = await apiClient.get<ProjectApiKey[]>(`/api/projects/${projectId}/api-keys`);
  return res.data;
}

export async function createProjectApiKey(
  projectId: string,
  body: { label: string; valid_days: number },
): Promise<CreatedProjectApiKey> {
  const res = await apiClient.post<CreatedProjectApiKey>(
    `/api/projects/${projectId}/api-keys`,
    body,
  );
  return res.data;
}

export async function revokeProjectApiKey(projectId: string, keyId: string): Promise<ProjectApiKey> {
  const res = await apiClient.post<ProjectApiKey>(
    `/api/projects/${projectId}/api-keys/${keyId}/revoke`,
  );
  return res.data;
}

export async function renewProjectApiKey(
  projectId: string,
  keyId: string,
  validDays: number,
): Promise<CreatedProjectApiKey> {
  const res = await apiClient.post<CreatedProjectApiKey>(
    `/api/projects/${projectId}/api-keys/${keyId}/renew`,
    { valid_days: validDays },
  );
  return res.data;
}
